/* eslint-disable prettier/prettier */
const isAsia = window.location?.origin.includes('book.marriottvacationclub.asia');

export default isAsia;